import React, { Component } from "react";
import { Link } from "react-router-dom";
import ShieldLogo from "../images/shield-vault.png";
import Web3 from "web3";
import Countdown from "./countdown";

class ProjectItem extends Component {
  details = {};
  launchPad = null;
  constructor(props) {
    super(props);
    this.details = props.details;
    this.launchPad = props.launchPad;
    const raisedFunds = Web3.utils.toBN(this.details.raisedFunds.hex);
    const softCap = Web3.utils.toBN(this.details.softCap.hex);
    this.presaleOpenAt = Web3.utils
      .toBN(this.details.presaleOpenAt.hex)
      .muln(1000)
      .toNumber();
    this.presaleCloseAt = Web3.utils
      .toBN(this.details.presaleCloseAt.hex)
      .muln(1000)
      .toNumber();
    let progress = Web3.utils.fromWei(
      raisedFunds
        .mul(Web3.utils.toBN(Web3.utils.toWei("1", "ether")))
        .div(softCap)
        .muln(100)
    );
    progress = isNaN(progress) ? 0 : progress;
    this.setState({ progress });
    this.state = {
      isWhiteListEnabled: this.details.onlyWhitelistedAllowed,
      projectUrl: `/project/${props.details.presaleAddress}`,
      progress,
    };
  }
  render() {
    return (
      <div className="col-lg-6 col-sm-12 text-center justify-content-center">
        <div className="single-item">
          {this.state.isWhiteListEnabled ? (
            <span
              className="badge project-access"
              style={{
                float: "right",
              }}
            >
              Private
            </span>
          ) : null}
          <div className="pp-card-body">
            <div className="pp-card-top">
              <Link to={this.state.projectUrl}>
                <span className="icon-box">
                  <span>
                    <img src={ShieldLogo} alt="#" />
                  </span>
                </span>
              </Link>
              <div className="title-box">
                <h3 className="d-flex align-items-center">
                  <div>
                    <Link to={this.state.projectUrl} style={{ color: "white" }}>
                      {this.details.tokenName}
                    </Link>
                  </div>
                </h3>
                <div className="item-social">
                  <a
                    href="https://www.shieldnetwork.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fas fa-globe"></i>
                  </a>
                  <a
                    href="https://twitter.com/ShieldNet_io"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCj1G0dDyzKivFfoVaf1ygAg"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    href="https://t.me/shieldnetio"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-telegram"></i>
                  </a>
                </div>
                <Link className="items-morex" to={this.state.projectUrl}>
                  <span className={"pp-status-" + this.props.status}>
                    <i className="fa fa-circle"></i> {this.props.statusText}{" "}
                    <Countdown
                      date={
                        this.presaleOpenAt > Date.now()
                          ? this.presaleOpenAt
                          : this.presaleCloseAt > Date.now()
                          ? this.presaleCloseAt
                          : this.presaleOpenAt > 0
                          ? this.presaleOpenAt
                          : 0
                      }
                    />
                  </span>
                  <div>
                    <span className="">BNB</span>
                  </div>
                </Link>
              </div>
            </div>
            <div className="item-desc mb-1">
              <div className="item-short-desc">{this.details.description}</div>
              <div className="item-learn-more"></div>
            </div>
            <div className="part-prize">
              <div className="pp-card-info">
                <div className="pp-card-col">
                  Swap rate
                  <br />
                  <b className="nowrap">
                    {Web3.utils.toBN(this.details.rate.hex).gtn(0) ? (
                      <>
                        1 BNB ={" "}
                        {parseFloat(
                          Web3.utils.fromWei(
                            Web3.utils.toBN(this.details.rate.hex)
                          )
                        ).toLocaleString()}{" "}
                        {this.details.tokenSymbol}
                      </>
                    ) : (
                      "TBA"
                    )}
                  </b>
                </div>
                <div className="pp-card-col text-end">
                  Soft Cap
                  <br />
                  <b>
                    {Web3.utils.toBN(this.details.softCap.hex).gtn(0)
                      ? Web3.utils.fromWei(
                          Web3.utils.toBN(this.details.softCap.hex)
                        )
                      : "TBA"}{" "}
                    BNB
                  </b>
                </div>
                {/* <div className="pp-card-col text-end">
                  Access
                  <br />
                  <b>
                    {this.state.isWhiteListEnabled === undefined
                      ? "-"
                      : this.state.isWhiteListEnabled
                      ? "Private"
                      : "Public"}
                  </b>
                </div> */}
              </div>
              <div className="pp-card-info d-block">
                <div className="pp-card-progress-wrap">
                  <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                    <div className="pp-card-col">Progress</div>
                  </div>
                  <div className="pp-card-progress">
                    <div
                      className="pp-card-progress-percent"
                      style={{
                        width:
                          (parseFloat(this.state.progress) > 100
                            ? 100
                            : this.state.progress) + "%",
                      }}
                    ></div>
                    <div className="pp-card-progress-label">
                      <span>
                        <b>{parseFloat(this.state.progress).toFixed(2)}%</b>
                      </span>
                      <span className="text-allocation">
                        <b>
                          {Web3.utils.toBN(this.details.softCap.hex).gtn(0) ? (
                            <>
                              {Web3.utils.fromWei(
                                Web3.utils.toBN(this.details.raisedFunds.hex)
                              )}
                              /
                              {Web3.utils.fromWei(
                                Web3.utils.toBN(this.details.softCap.hex)
                              )}
                            </>
                          ) : "TBA/TBA"}
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectItem;
